import _toConsumableArray from "E:/Jweb/\u7ED3\u8BFE\u4F5C\u4E1A/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import { reactive, ref } from "vue";
import { getPostArticleList } from "../../api/article";
import { defaultThumbnail } from "../../utils/thumbnail";
export default {
  name: "ArchiveDetails",
  setup: function setup(props) {
    var pageSize = 10;
    var postArticles = reactive([]);
    var articleCount = ref(0);
    onCurrentPageChanged(1);

    function onCurrentPageChanged(pageNum) {
      getPostArticleList(pageNum, pageSize, null, null, props.year + "/" + props.month).then(function (data) {
        articleCount.value = parseInt(data.total);
        data.rows.forEach(function (article) {
          article.createTime = article.createTime.split(" ")[0];
          article.thumbnail = article.thumbnail || defaultThumbnail;
        });
        postArticles.splice.apply(postArticles, [0, postArticles.length].concat(_toConsumableArray(data.rows)));
      });
    }

    window.scrollTo({
      top: 0
    });
    return {
      postArticles: postArticles,
      articleCount: articleCount,
      pageSize: pageSize,
      onCurrentPageChanged: onCurrentPageChanged
    };
  },
  props: ["year", "month"]
};